module.exports = __webpack_public_path__ + "5b80f8cb73469d20427341a16788c119.svg";